import React from 'react'
import { graphql } from 'gatsby'
import { Helmet } from 'react-helmet'
import Layout from '~/components/Layout'
import Metadata from '~/components/Metadata'
import ClubHousePage from '~/components/Clubhouse/Page'

const ClubHouse = ({ data }) => {
  const { page } = data

  return page ? (
    <Layout
      footerColors={{
        background: '#FFDD00',
        color: '#FF5A47',
        logoFront: '#FFDD00',
        logoBack: '#FF5A47',
      }}
    >
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css2?family=Cedarville+Cursive&display=swap"
          rel="stylesheet"
        />
        <style type="text/css">
          {`
            body {
              font-family: 'Cedarville Cursive', cursive;
            }
          `}
        </style>
      </Helmet>
      <Metadata title={page.name} />
      <ClubHousePage page={page} />
    </Layout>
  ) : null
}

export default ClubHouse

export const query = graphql`
  query ClubHousePage($locale: String) {
    page: contentfulPage(
      slug: { eq: "club-house" }
      node_locale: { eq: $locale }
    ) {
      ...ContentHeroFragment
      ...ContentPageFragment
    }
  }
`
